<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <div class="row">
    <div class="container">
      <div class="dialog-title">New User</div>
      <cyborg-error *ngIf="error" [error]="error"></cyborg-error>
      <form
        class="k-form"
        [formGroup]="formGroup"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
      >
        <div class="k-two-col">
          <kendo-formfield>
            <label for="firstName">First Name*</label>
            <input
              id="firstName"
              formControlName="firstName"
              maxlength="50"
              kendoTextBox
            />
            <kendo-formerror>Error: First name is required</kendo-formerror>
          </kendo-formfield>
          <kendo-formfield>
            <label for="lastName">Last Name*</label>
            <input
              id="lastName"
              formControlName="lastName"
              maxlength="50"
              kendoTextBox
            />
            <kendo-formerror>Error: Last name is required</kendo-formerror>
          </kendo-formfield>
        </div>
        <div class="k-two-col">
          <kendo-formfield>
            <label for="email">Email*</label>
            <input
              id="email"
              formControlName="email"
              maxlength="50"
              kendoTextBox
            />
            <kendo-formerror *ngIf="formGroup.controls.email.errors?.required"
              >Error: Email is required</kendo-formerror
            >
            <kendo-formerror *ngIf="formGroup.controls.email.errors?.email"
              >Error: Not valid email format</kendo-formerror
            >
          </kendo-formfield>
          <kendo-formfield>
            <label for="role">Role*</label>
            <kendo-dropdownlist formControlName="role" [data]="roles">
            </kendo-dropdownlist>
          </kendo-formfield>
        </div>
        <button
          themeColor="primary"
          class="dialog-button"
          size="large"
          type="submit"
          [disabled]="!formGroup.valid"
          kendoButton
        >
          Save
        </button>
      </form>
    </div>
  </div>
</div>
